import React from "react";
import { Link } from "react-router-dom";
import { Sparkles as SparkIcon } from "lucide-react";
import { SERVICE_NODES, BENEFITS } from "../../../lib/ecosystemData";

const MobileNodeCard = ({ node, locale }) => {
  const Icon = node.icon;
  return (
    <Link
      to={`/services/${node.slug}`}
      data-testid={`ecosystem-node-${node.slug}`}
      className="glass-strong rounded-2xl p-4 flex items-start gap-3 hover:border-brand-orange/50 transition-all"
    >
      <div className="w-9 h-9 rounded-full bg-brand-orange/12 border border-brand-orange/45 flex items-center justify-center shrink-0">
        <Icon className="w-4 h-4 text-brand-orange" />
      </div>
      <div className="flex-1">
        <div className="font-display font-bold text-white text-sm mb-1">{node.label[locale]}</div>
        <div className="text-[11px] text-white/60 leading-snug">
          {node.bullets[locale].slice(0, 2).join(" · ")}
        </div>
      </div>
    </Link>
  );
};

const Connector = () => (
  <div className="flex justify-center my-1"><div className="w-px h-6 bg-brand-orange/50" /></div>
);

/** Mobile (< md) fallback: vertical stack of nodes → hub → nodes. */
export const EcosystemMobile = ({ locale }) => (
  <div className="md:hidden relative max-w-md mx-auto flex flex-col items-stretch gap-3">
    {SERVICE_NODES.slice(0, 3).map((n) => (
      <MobileNodeCard key={n.slug} node={n} locale={locale} />
    ))}
    <Connector />
    <div className="relative w-[200px] h-[200px] mx-auto flex items-center justify-center">
      <div className="absolute inset-0 rounded-full border border-brand-orange/40 eco-hub-breathe" />
      <div className="absolute inset-3 rounded-full bg-brand-orange/15 blur-2xl" />
      <div className="relative w-[150px] h-[150px] rounded-full bg-[#0B0C12] border border-brand-orange/60 shadow-[0_0_60px_rgba(255,106,0,0.35)] flex flex-col items-center justify-center text-center px-3">
        <SparkIcon className="w-4 h-4 text-brand-orange mb-1.5" />
        <div className="font-display font-bold text-white text-base leading-tight">JOSHI</div>
        <div className="font-display font-bold text-white text-base leading-tight">
          FUSION<span className="text-brand-orange">TECH</span>
        </div>
        <div className="font-display text-[9px] tracking-[0.32em] text-white/70 mt-0.5">MEDIA</div>
      </div>
    </div>
    <Connector />
    {SERVICE_NODES.slice(3).map((n) => (
      <MobileNodeCard key={n.slug} node={n} locale={locale} />
    ))}
  </div>
);

/** Benefits bar below the diagram. */
export const EcosystemBenefits = ({ locale, isDE }) => (
  <div className="relative max-w-6xl mx-auto mt-8 md:mt-10">
    <div className="glass rounded-3xl p-5 md:p-7">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {BENEFITS.map((b, i) => {
          const Icon = b.icon;
          return (
            <div
              key={b.title.en}
              data-testid={`ecosystem-benefit-${i}`}
              className="rounded-2xl p-4 transition-all hover:bg-white/[0.03]"
            >
              <div className="w-10 h-10 rounded-xl bg-brand-orange/12 border border-brand-orange/35 flex items-center justify-center mb-3">
                <Icon className="w-4 h-4 text-brand-orange" />
              </div>
              <div className="font-display font-semibold text-white text-sm leading-snug">{b.title[locale]}</div>
              <div className="mt-1.5 text-[12px] text-white/60 leading-snug">{b.desc[locale]}</div>
            </div>
          );
        })}
      </div>
    </div>
    <div className="text-center mt-8 label-mono text-white/55">
      {isDE
        ? "Ein Ökosystem · Ein Partner · Unbegrenzte Möglichkeiten"
        : "One Ecosystem · One Partner · Limitless Possibilities"}
    </div>
  </div>
);
